import { z } from 'zod'
import { Position } from 'src/common-services/types/geojson-types'

export type Place = {
  placekey: string
  position: Position
  name: string
  brands: string[]
  address: string
  milesFrom: number
  brandIds: string[]
  city: string
  state: string
  naicsCode: string
  msaNumber?: string
  county?: string
}

export type PlaceFootfall = {
  date: string
  monthlyVisits: number
  dailyVisits: number[]
  tractNormalizedVisits: number
  tractNormalizedVisitors: number
  rawVisits: number
  rawVisitsByDay: number[]
  totalVisitsNormalized: number
  totalVisitorsNormalized: number
  regionVisitsNormalized: number
  regionVisitorsNormalized: number
  deviceCount: number
  brands: string[]
  uniqueRatio: number
}

export const placesRankRequestSchema = z.object({
  placekey: z.string(),
  naicsCode: z.string().optional(),
  state: z.string().optional(),
  city: z.string().optional(),
  brandId: z.string().optional(),
})

export type PlacesRankRequest = z.infer<typeof placesRankRequestSchema>

const polygonSchema = z.object({
  geometry: z.object({
    type: z.literal('Polygon'),
    coordinates: z.array(z.array(z.array(z.number()))),
  }),
})

export const placesByBrandRequestSchema = z.object({
  brandId: z.string(),
  polygon: polygonSchema,
})
export type PlacesByBrandRequest = z.infer<typeof placesByBrandRequestSchema>

export const placesByCategoriesRequestSchema = z.object({
  categories: z.array(z.string()),
  polygon: polygonSchema,
})
export type PlacesByCategoriesRequest = z.infer<typeof placesByCategoriesRequestSchema>
